import { IHCPhoneWorkingHours } from '../../indigofair/helpcenter/IHCPhoneWorkingHours';
import { SettingConst } from '../../types';

/**
 * Working hours for phone support in different countries
 */
export const HELP_CENTER_PHONE_WORKING_HOURS =
  'HELP_CENTER_PHONE_WORKING_HOURS' as SettingConst<
    'HELP_CENTER_PHONE_WORKING_HOURS',
    IHCPhoneWorkingHours,
    'HELP_CENTER' | 'RETAILER_IOS' | 'RETAILER_ANDROID'
  >;
